import { action } from "../utils/actions";

export const clearError = () => action("CLEAR_NOTIFICATION_ERROR");
